import React, { createContext, useContext, useEffect, useState } from 'react';
import ModalTask from 'components/Organisms/Modals/ModalTask/ModalTask';
import iconCortPng from 'assets/images/home.png';
import Step1 from './Step1/Step1';
import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Step2 from './Step2/Step2';
import {
  Entity,
  Loan,
  Task,
  TaskResponse,
  TaskState
} from '../../../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../../../services/task/querys';
import { LoanContext } from '../../Dashboard';
import StateTag from 'components/Atoms/Tags/StateTag/StateTag';
import { findTaskRules } from '../../RulesTaskCards.constanst';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { TaskOpenModalContext } from '../../../Private';
import CircleTag from 'components/Atoms/Tags/CircleTag/CircleTag';

export const TaskContext = createContext<Task | {}>({});
export const EntityContext = createContext<Entity | {}>({});

interface Props {
  task: Task;
}

const TrackRecord = ({ task }: Props) => {
  const loan: Loan | any = useContext(LoanContext);
  const { value: openContext, setHandler }: any = useContext(TaskOpenModalContext);

  const { data: taskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [step, setStep] = useState(1);
  const [responseStep2, setResponseStep2] = useState<TaskResponse>();
  const [entity, setEntity] = useState<Entity | any>();
  const [isReview, setIsReview] = useState(false);

  useEffect(() => {
    if (openContext === 'track_record') {
      setModalTaskVisible(true);
      setHandler();
    } else if (!!openContext)
      setModalTaskVisible(false);
  }, [openContext]);

  useEffect(() => {
    /*const step1 = taskResponses?.find(
      (item) => item.step === 1 && item.key === 'yes'
    );
    if (step1) setStep(2);*/

    const step2: any = taskResponses?.find((item) => item.step === 1);
    setResponseStep2(step2);
    setIsReview(step2?.state === TaskState.Review);
  }, [taskResponses]);

  const onHelpDocs = () => {
    console.log('onHelpDocs');
  };
  
  const filesIgnoreError = responseStep2?.files?.filter(item => item.state !== 'request_error') || [];

  const renderTracker = () => (
    <div style={{ height: '100%' }}>
      <span className='title-summary'>Task summary</span>
      <div className="text-footer mt-20">
        <p className="description">
          I’ve purchased/sold{' '}
          <span className="tag-blue">
            {loan?.investmentExperience?.properties === 'none' ? 'no' : loan?.investmentExperience?.properties}
          </span>{' '}
          real estate properties in the past 24 months
        </p>

        <div>
          <p
            className="placeholder"
            style={{ marginTop: 40, fontWeight: 500 }}
          >
            Document status{' '}
          </p>

          {taskResponses && (
            <div className="owners-tags mt-5">
              <span>{filesIgnoreError?.length > 0? 1: 0}/1 submitted</span>
            </div>
          )}

          <div className="mt-10 circles-tags">
            <CircleTag
              state={(filesIgnoreError[filesIgnoreError.length - 1]?.state) || ''}
              tagKey={(filesIgnoreError[filesIgnoreError.length - 1]?.state) || ''}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const { taskName } = findTaskRules(ModuleKeys.TRACK_RECORD);

  return (
    <TaskContext.Provider value={task}>
      <EntityContext.Provider value={entity}>
        <ModalTask
          visible={isModalTaskVisible}
          handlerSetVisibile={setModalTaskVisible}
          isConfirmModalClose={task.state !== TaskState.Approved && !isReview}
          responses={taskResponses}
          renderButtonTrigger={(openModal: any) => (
            <Button
              className={`button-open-modal button-open-modal-${task.state}`}
              onClick={() => openModal(true)}
            >
              {(task.state === TaskState.Review || task.state === TaskState.Approved) ? 'View task' :
                (task.state === TaskState.Incomplete) ? 'Complete task' :
                (task.state === TaskState.RequestError) ? 'Resolve issues' :
                  'Begin Task'
              }
            </Button>
          )}
          header={{
            title: <span>{taskName.toUpperCase()}</span>,
            actionLeft: (
              isReview ? <StateTag state={TaskState.Review} size="large" /> : <img src={iconCortPng} alt="icon" className="paperPng" />
            ),
            actionRight: (
              <Button
                className="button button-transparent"
                onClick={() => onHelpDocs()}
              >
                <QuestionCircleOutlined />
                Help docs
              </Button>
            )
          }}
          animationDirection="onRight"
          stepsTotal={1}
          currentStep={step}
          setStep={setStep}
          tracker={renderTracker()}
        >
          <section className="children AchPaymentForm">
            <Step2
              setStep={setStep}
              closeTask={() => setModalTaskVisible(false)}
            />
          </section>
        </ModalTask>
      </EntityContext.Provider>
    </TaskContext.Provider>
  );
};
export default TrackRecord;
